import _ from "underscore";

export default class Messages {
    private locale?: string;
    private isMultilang: boolean;

    private messages: {[key: string]: string};
    private multilangMessages?: {[key: string]:{[key: string]: string}};
    private defaultDictionary = {
        nextButton: "Next",
        backButton: "Back",
        validateMessage: "Enter the answer",
        valuesCheckNumeric: "Enter the number",
        valuesCheckNumericRange: "Enter the number in range {rangeMin} to {rangeMax}",
        valuesCheckNumericDecimal: "Enter the number. Use the decimal point if needed",
        valuesCheckStringRange: "Enter string long {rangeMin} to {rangeMax} characters",
        valuesCheckDate: "Enter the date in the format of day.month.year (eg: 13.2.2020)",
        valuesCheckRegexp: "Enter a string in the form of {pattern}",
        valuesCheckEmail: "Enter a valid email",
        blockedImage: "We are sorry, but this browser specific settings (or plugins activities) blocked the key elements of this question, questioning can't continue",
        questionaryFinished: "Questionary finished, saving data.",
        comboPlaceholder: "-- select --",
        valuesCheckImageHighlighterCategoryHasTooFewItems: "You have selected too few items in the category {category}. Minimum is {minimum}, you have selected {selected}",
        valuesCheckSlider: "To continue, click or move the slider.",
        valuesCheckScanner: "Load the value",
        scannerStateEmpty: "Not loaded",
        scannerStateFilled: "Loaded",
        savingTakesLongerThanUsual: "Saving takes longer than usual",
        savingFailed: "Saving failed.",
        savingFeedbackFailed: "Saving feedback failed.",
        tryAgain: "Try again",

        // SE3 addition
        letsGetStarted: "Lets get started!",
        tapOrArrowsToSetDate: "Tap on date or use arrows to set the date in {format} format.",
        tapOrArrowsToSetTime: "Tap on time or use arrows to set the time in {format} format.",
        clickAndStartTypingText: "Click in the text box to start typing",
        clickAndStartTypingNumber: "Click in the box to start typing number",
        inflateTheBalloon: "Inflate the balloon!",
        minigameBalloonIntroHint: "Wanna break, try quick game with balloons. Press START to play or SKIP if you don't like balloons.",
        batteryFinished: "Continue to next question.",
        gotIt: "Got it!",
        ifYouAgreeSwipeRightDisagreeSwipeLeft: "If you agree with the statement swipe card to the right. Otherwise swipe left.",
        awesomeYouFinishGuide: "Awesome, you finished the guide!",
        pressGotItToContinue: "Tap on \"<b>Got it!</b>\" to continue.",
        swipeRight: "Swipe right",
        swipeLeft: "Swipe left",
        swipeToSelectAge: "Swipe to set your age.",
        swipeToSelectNumber: "Swipe to select number.",
        fileUploaded: "File uploaded.",
        filesExceededMaxSize: "Files exceeded maximum upload size.",
        waitPlease: "Wait please.",
        pickupFile: "Select file(s)",
        pickupMoreFiles: "Select more files",
        filesNotUploaded: "File(s) {files} are not uploaded.",
        press: "Press",
        selectLanguage: "Select language",
        selectRecommendationRate: "Select a recommendation rate on the scale",
        whyDidYouMarkThisPlace: "Why did you mark this place?",
        pickDay: "Pick a day",
        pickDatetime: "Pick a time and date",
        pickWeek: "Pick a week",
        pickRange: "Pick a date range",
        clickToMicToDict: "You can dictate the answer to us. Click on the microphone icon to record.",
        textHighlighterHint: 'Please mark the most important parts (words/sentences) with <strong class="text-success">green color</strong>, irrelevant parts with <strong class="text-danger">red color</strong>.',
        whyDidYouMarkThisText: 'Why did you mark this words?',
        saveComment: 'Save comment',
        rubber: 'Erase',
        acquiringLocation: 'Acquiring location',
        allowLocation: 'Allow to read GPS location',
        loading: 'Loading',
        select: 'Select',
        continue: 'Continue',
        search: 'Search',
        playerTroubleshooting: 'Player troubleshooting<ol><li><b>Issue:</b> Player is indicating playing, but you cannot hear anything.<br/><b>Solution:</b> Turn the volume up on your device. Check headphones / speakers cable.</li><li><b>Issue:</b> Unable to start playing. No sound, no player animation.<br><b>Solution:</b> Try different web browsers, we recommend Google Chrome.</li></ol>If problems persists, please let us know by clicking on button <b>REPORT ISSUE</b> in the upper right corner. Thank you.',
        playerHelp: "No sound or player is not working",
        playerClickToPlay: "Click on button to start",
        playerChooseImageBySound: "Assign a picture to appropriate sound",
        playerTestWarning: "Please listen carefully to a sample once again and choose the right answer. If you don't recognise a sound, the survey will end.",
        playerFinished: 'Thanks for passing the test',
        download: 'Download',
        generatingReport: 'Generating report. Please wait.',
        generatingReportError: 'Generating failed. Please check your internet connection.',
        mapPinHint: 'Click to add a pin to the map. Click on a pin to remove it.',
        mapPinHintMinLimit: 'Click to add a pin to the map. Click on a pin to remove it. Add at least {min} points.',
        mapPinMaxPointsLimit: 'Cannot add more than {max} points.',
        mapPinOutOfArea: 'This location is outside the allowed area.',
        remove: 'Remove',
        empty: 'Empty',
        noItemsFound: 'No items found.',
        resetFilter: 'Reset filter',
        chaptersCompleted: 'Chapters are completed.',
    };

    constructor(messages?: {[key: string]: string}) {
        this.isMultilang = false;
        this.messages = _.extend(this.defaultDictionary, messages);
    }

    multilang(multilangMessages?: {[key: string]:{[key: string]: string}}) {
        this.isMultilang = true;
        this.multilangMessages = {};

        // Save dictionaries
        for (let locale in multilangMessages) {
            let dictionary = multilangMessages[locale];
            let defaults = _(this.messages).clone();
            this.multilangMessages[locale] = _.extend(defaults, dictionary);
        }

    }

    public getLocale(): string|null {
        return this.locale || null;
    }

    public setLocale(locale: string) {
        this.locale = locale;
    }


    get(key: string, options?:{[key: string]: string}) {

        // Pickup dictionary - base messages or from multilang messages by locale
        let dictionary : {[key: string]: string};
        if (this.isMultilang && this.locale) {
            dictionary = this.multilangMessages![this.locale] ? this.multilangMessages![this.locale] : this.defaultDictionary;
        } else {
            dictionary = this.messages;
        }

        // search translate
        const text = dictionary[key];

        // Oh no, the translation missing! Return original message
        if(text === undefined) {
            return key;
        }

        // Well, we got it! The translation almost perfect, let replace {variables}
        return _.keys(options).reduce((acc, key) => this.replaceAll(acc, '{' + key + '}', options![key]), text);
    }

    private replaceAll(string: string, needle: string, replacement: string) {
        return string.split(needle).join(replacement);
    }
}